import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {

  constructor() { }

  transform(value: any, language: string, format = 'MMM d, y'): string {
    const datePipe = new DatePipe(language);
    return datePipe.transform(value, format) || '';
  }

}
